/*Mobile & Tracker */
export const SENTINEL_MOBILE_TRACKER = 2;
export const SENTINEL_TMA = 10;
export const SENTINEL_MOBILE = SENTINEL_TMA;
export const SENTINEL_TRACKER = 12;
export const SENTINEL_TRAILER = SENTINEL_TRACKER;

/*Impact Tracker */
export const SENTINEL_V0 = 1;
export const SENTINEL_V3 = 3;
export const SENTINEL_V4 = 4;
export const SENTINEL_V5 = 5;
export const SENTINEL_V6 = 6;
export const SENTINEL_V7 = 7;
export const SENTINEL_V8 = 8;
export const SENTINEL_V9 = 9;

/*Trailer unit as the API numbers it (SENTINEL_MOBILE_TRAILER); the portal has
  always treated trailers as SENTINEL_TRACKER above, so this is only used for
  labelling what the API sends back. */
export const SENTINEL_MOBILE_TRAILER = 11;

/** Human readable name for a devicetype_id, as the API numbers them. */
export const DEVICE_TYPE_LABELS = {
  [SENTINEL_V0]: "Demo",
  [SENTINEL_MOBILE_TRACKER]: "Mobile Tracker",
  [SENTINEL_V3]: "Impact Tracker V3",
  [SENTINEL_V4]: "Impact Tracker V4",
  [SENTINEL_V5]: "Impact Tracker V5",
  [SENTINEL_V6]: "Impact Tracker V6",
  [SENTINEL_V7]: "Impact Tracker V7",
  [SENTINEL_V8]: "Impact Tracker V8",
  [SENTINEL_V9]: "Impact Tracker V9",
  [SENTINEL_TMA]: "Mobile (TMA)",
  [SENTINEL_MOBILE_TRAILER]: "Mobile (Trailer)",
  [SENTINEL_TRACKER]: "Tracker",
};

export function deviceTypeLabel(id) {
  if (id == null) return "";
  return DEVICE_TYPE_LABELS[id] || `Type ${id}`;
}
